import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Header from './Headstu';
import axios from '../Axiosinstance'
import { useParams } from 'react-router-dom';
import { Table, Button, Typography, Box, Paper, Grid, Divider, TableBody, TableRow, TableCell } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaTrash } from 'react-icons/fa';
import { TextField, Select, MenuItem, Modal, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePowerpoint } from '@fortawesome/free-solid-svg-icons'; // Import the specific icon you want to use

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { decryptData } from '../Axiosinstance';
import { batch } from 'react-redux';

const extractYouTubeVideoId = (url) => {
  // Extract the video ID from the YouTube URL
  const videoId = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=|embed\/watch\?feature=player_embedded&v=))([^&\n?#]+)/);
  return videoId ? videoId[1] : null;
};

const Key = () => {
  // const { id } = useParams();
  const { id: encodedId } = useParams(); // Get encoded batchId
  const id = decryptData(decodeURIComponent(encodedId)); // Decode & Decrypt

  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedContent, setSelectedContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [filteredStartModulus, setFilteredStartModulus] = useState([]);
  const [filteredModules, setFilteredModules] = useState([]);

  const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

  useEffect(() => {
    axios.get(`module-content/batch/${id}`)
      .then((response) => {
        setModules(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
      });
  }, [id]);

  useEffect(() => {
    const fetchBatchIds = async () => {
      try {
        const response = await axios.get(`registrationadvances/student/${studentTeacherId}/registration-advances`);
        const studentData1 = response.data[0];
        setStudentData(studentData1); // First, update state
        console.log("hida", studentData1);
      } catch (error) {
        console.error("Error fetching batch data:", error);
      }
    };

    if (studentTeacherId) {
      fetchBatchIds();
    }
  }, [studentTeacherId]);

  useEffect(() => {
    if (studentData?.scheduleDate) {  // Ensure studentData and scheduleDate exist
      const currentDate = new Date().toISOString().split("T")[0];

      const firstModuleId = studentData?.scheduleDate[0]?.startModulus;

      const filteredModulus = studentData?.scheduleDate
        .filter(item => item.startDate <= currentDate || item.startModulus === firstModuleId)
        .map(item => item.startModulus);

      // setFilteredStartModulus(filteredModulus);

      // Find matching modules based on startModulus
      const matchedModules = studentData?.batch?.moduleDetails
        .filter(module => filteredModulus.includes(module.id)) // Match startModulus with module id
        .map(module => ({
          id: module.id,
          moduleName: module.moduleName
        }));

        setFilteredStartModulus(matchedModules);
        console.log("matchedModules",matchedModules)

        const filteredModules = modules.filter(module => 
          matchedModules.some(matched => matched.moduleName === module.name)
        );
        setFilteredModules(filteredModules);
    }
  }, [studentData,modules]); // Runs only when studentData updates



  // Run once on mount

  console.log(filteredStartModulus);
  const handleModuleClick = (module) => {
    console.log("module", module);
    setSelectedModule(module);
    setSelectedContent(null); // Reset selected content when switching modules
  };

  // const handleContentClick = (content) => {
  //   setSelectedContent(content);
  // };

  const modalHeaderName = "Couse ";


  const handleContentClick = (file) => {
    setSelectedContent(file);
    setIsModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedContent(null); // Clear selected content when closing
  };

  const renderIframeContent = (content) => {
    switch (content.type) {
      case 'pdf': // PDF files
        return (
          <iframe
            src={content.fileUrl}
            style={{ width: '100%', height: '100%' }}
            title="PDF Viewer"
          ></iframe>
        );
      case 'ppt': // PowerPoint files
        return (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(content.fileUrl)}`}
            style={{ width: '100%', height: '100%' }}
            title="PowerPoint Viewer"
          ></iframe>
        );
      case 'video': // Video files
        return (
          <video width="100%" height="auto" controls>
            <source src={content.fileUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      case 'youtube link': // YouTube links
        return (
          <iframe
            src={content.fileUrl.replace("youtu.be", "www.youtube.com/embed").split("?")[0]} // Convert to embeddable format
            style={{ width: '100%', height: '100%' }}
            title="YouTube Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      case 'text': // Plain text or HTML content
        return (
          <div
            style={{
              padding: '10px',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
            }}
            dangerouslySetInnerHTML={{ __html: content.fileUrl }}
          ></div>
        );
      default: // Unsupported formats
        return (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: 'red', fontWeight: 'bold' }}>
              Unsupported format: {content.type}
            </p>
          </div>
        );
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <Paper
        elevation={4}
        style={{
          padding: '20px',
          borderRadius: '15px',
          background: '#ffffff',
          maxWidth: '1000px',
          margin: '0 auto',
        }}
      >
        <Typography
          variant="h4"
          style={{
            fontWeight: 'bold',
            marginBottom: '20px',
            color: '#333',
            textAlign: 'center',
          }}
        >
          <FontAwesomeIcon
            icon={faFilePowerpoint}
            style={{ marginRight: '10px', color: '#3f51b5' }}
          />
          Course Content
        </Typography>

        {/* Module List */}
        <Box p={2} style={{ background: '#f0f4f8', borderRadius: '8px', marginBottom: '20px' }}>
          <Typography variant="h5" style={{ color: '#555', fontWeight: 'bolder' }}>
            Module Lists
          </Typography>

          <Divider />
          <br />
          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))"
            gap="16px"
          >
            {filteredModules?.map((module) => (
              <Button
                key={module.id}
                variant="contained"
                color="primary"
                style={{
                  height: "50px",
                  textTransform: "none",
                  fontSize: "15px",
                  minWidth: "200px",
                  width: "100%", // Ensures buttons take full width of their grid cell
                }}
                onClick={() => handleModuleClick(module)}
              >
                {module.name}
              </Button>
            ))}
          </Box>
        </Box>

        {/* Content List */}
        <Box p={2} style={{ background: '#f0f4f8', borderRadius: '8px', marginBottom: '20px' }}>
          <Typography variant="h5" style={{ marginBottom: '10px', color: '#555', fontWeight: 'bolder' }}>
            Module Content
          </Typography>
          <Divider />
          <br />
          <Table>
            <TableBody>
              {selectedModule?.files.map((file) => (
                <TableRow
                  key={file.id}
                  onClick={() => handleContentClick(file)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedContent?.id === file.id ? '#e3f2fd' : 'transparent',
                    transition: 'background 0.3s',
                    borderRadius: '8px',
                  }}
                >
                  <TableCell style={{ fontSize: '18px', fontWeight: '800', padding: '12px' }}>
                    {file.fileName}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Paper>

      {/* Modal for Full-Container View */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: '#ffffff',
            borderRadius: '15px',
            padding: '20px',
            width: '90%',
            height: '90%',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            overflow: 'auto',
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            style={{ position: 'absolute', top: '10px', right: '10px' }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </IconButton>
          {/* Modal Header */}
          <Typography
            variant="h6"
            component="h2"
            style={{
              marginBottom: "20px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {selectedContent?.fileName}
          </Typography>
          {selectedContent && renderIframeContent(selectedContent)}
        </Box>
      </Modal>
    </div>
  );
};

// export default Key;

const Managec = () => {
  return (
    <div >
      <Header />

      <Key />
    </div>
  );
};

export default Managec;

function renderDownloadButton(content, type) {
  // Check if the content type is not a YouTube link and type is defined
  if (type && type !== 'youtube') {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleDownload(content.fileUrl, type)}>
        Download {type.toUpperCase()}
      </Button>
    );
  }

  // No download button for YouTube links or if type is undefined
  return null;
}

function handleDownload(fileUrl, type) {
  // Implement download logic here
  if (type === 'text') {
    downloadTextFile(fileUrl, 'download.txt');
  } else if (type === 'pdf' || type === 'ppt') {
    downloadFile(fileUrl, `download.${type}`);
  } else {
    window.location.href = fileUrl; // This is a simple example; improve based on your requirements
  }
}


function downloadTextFile(htmlContent, fileName) {
  const element = document.createElement('a');

  // Convert HTML content to formatted plain text
  const plainTextContent = convertHtmlToPlainText(htmlContent);

  const file = new Blob([plainTextContent], { type: 'text/plain' });

  element.href = URL.createObjectURL(file);
  element.download = fileName;
  document.body.appendChild(element);
  element.click();
}

function convertHtmlToPlainText(htmlContent) {
  const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
  const textContent = doc.body.textContent || '';
  return decodeHtmlEntities(textContent);
}

function decodeHtmlEntities(text) {
  const element = document.createElement('div');
  element.innerHTML = text;
  return element.innerText;
}

function downloadFile(fileUrl, fileName) {
  fetch(fileUrl)
    .then(response => response.blob())
    .then(blob => {
      const element = document.createElement('a');
      const file = new Blob([blob], { type: 'application/octet-stream' });

      element.href = URL.createObjectURL(file);
      element.download = fileName;
      document.body.appendChild(element);
      element.click();
    })
    .catch(error => {
      console.error('Error downloading file:', error);
    });
}



